import { render, staticRenderFns } from "./SmtpRelay.vue?vue&type=template&id=015cda6b&scoped=true"
import script from "./SmtpRelay.vue?vue&type=script&lang=js"
export * from "./SmtpRelay.vue?vue&type=script&lang=js"
import style0 from "./SmtpRelay.vue?vue&type=style&index=0&id=015cda6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015cda6b",
  null
  
)

export default component.exports